module.exports = __webpack_public_path__ + "static/media/default-user.02d4c0fa.png";